import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { GeneralService, NotificacionService } from 'src/app/services/service.index';
declare const toastr: any;

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: []
})
export class GruposComponent implements OnInit { 
  
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
    dataUsers: any[];
    dataSourceGrupos: any[];
    
    model: any = {
      id: 0,
      grupo: '',
      estado: '',
      
    };
    selectedRows: number[];
    grupoId: number;
    grupo: string = '';
    popupVisibleAdd: boolean = false;
    popupVisibleDel: boolean = false;
    popupVisibleUs: boolean = false;
    state_toogle: boolean = false;
    vigencia: any[];
    baseUrl = environment.apiEndpoint;
    hasError: any;
    tipos: any[] = [{ id: 1, descripcion: 'AVISO' }, { id: 2, descripcion: 'MENSAJE' }];    

    constructor(private _fs: NotificacionService) {
      this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
      this.clearErrors();
      this.getGrupos();
    }
  
    ngOnInit() {
    }
  
    clearErrors() {
      this.hasError = { grupo: false};
    }
  
    getGrupos() {
      this._fs.getGrupos().subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {            
            this.dataSourceGrupos = result.data;
  
          }
          else { this.dataSourceGrupos = []; }
        },
        (error) => { console.log('Error', error); });
    }  

      onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'acciones'
      });
    }
  
   
  
    showModalAdd() {
      this.clearErrors();
      this.getGrupos();
      this.model.id = 0;
      this.model.grupo = '';      
      this.popupVisibleAdd = true;
    }
  
  
    showModalEdit(data: any) {
      this.clearErrors();
      this.model.id = data.id;
      this.model.grupo = data.grupo;      
      this.popupVisibleAdd = true;
    }  
    
    saveGrupo() {
      this.hasError = { titulo_aviso: false, detalle_aviso: false, fecha_aviso: false, tipo_aviso: false, grupo_id: false, aviso: false, con_documento_adjunto: false  };      
      if (this.validate(this.model)) {
        if (this.model.id == 0) {          
          this._fs.postGrupo(this.model).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getGrupos();
                this.popupVisibleAdd = false;              
                toastr.success('Datos guardados correctamente.');          
              } else {              
                toastr.warning(result.data); 
              }
            },
            error => { console.log('Error', error); });
        }
        else {
          this._fs.putGrupo(this.model).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getGrupos();
                this.popupVisibleAdd = false;              
                toastr.success('Datos guardados correctamente.');          
              } else {              
                toastr.warning(result.data); 
              }
            },
            error => { console.log('Error', error); });
        }
      }
    }
   
    showModalDelete(id: number) {      
      this.grupoId = id;
      this.popupVisibleDel = true;
    }
   
    deleteGrupo() {
      this._fs.deleteGrupo(this.grupoId).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getGrupos();
            this.popupVisibleDel = false;          
            toastr.success('Proceso realizado correctamente.');          
          } else {              
            toastr.warning(result.data);  
          }
        },
        error => { console.log('Error', error); });
    }
   
    validate(data: any) {
      let res = true;
      if (!UtilHelper.validator(data.grupo, 'text')) {
        this.hasError.grupo = true; res = false;
      }
      // if (!UtilHelper.validator(data.detalle_aviso, 'text')) {
      //   this.hasError.detalle_aviso = true; res = false;
      // }
    
      return res;
    }

    showModalUser(dg: any) {
      this.grupoId = dg.id;
      this.grupo = dg.grupo;
      this._fs.getUsuariosGrupo(dg.id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            
            this.dataUsers = result.data;
            this.selectedRows = this.dataUsers.filter(u => u.seleccionado == 1).map(u => u);
          } else {
            this.dataUsers = [];
            this.selectedRows = [];
          }
        });      
      this.popupVisibleUs = true;
    }

    saveUsers(a: any) {
      this._fs.postUsuariosGrupo({ grupo_id: this.grupoId, users: a.selectedRowKeys }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('Usuarios asignados correctamente.');
            this.popupVisibleUs = false;
          }
        });
      this.grupoId = 0;
      //console.log(a.selectedRowKeys);
    }
  }
  